import s from '../allservices.jsx'
import {
    Link, withRouter
} from 'react-router-dom';

const getCardService = (actionCallback, state) => {
    let token = "Token " + localStorage.getItem('token')
    fetch(s.get_cards + "/?Authorization=" + token, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token,
            
        },
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201  || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            }
            else if(res.status === 204){
               let data="No cards for this user."
                actionCallback(data,"emptyBody")
            }
             else if (res.status === 401) {
           
            //     localStorage.clear();
            //     this.props.history.push("/")
            let errorOut= "logout"
            actionCallback(errorOut)
            }
            else{
                 // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getCardService;


// WEBPACK FOOTER //
// ./src/services/components/get_card.jsx